import React from "react";
import MSICustomerNav from "./MSICustomerNav";
import "./msiCustomer.css";

const PREVIEW_UI_ENABLED = process.env.REACT_APP_PWG_PRODUCTION_RELEASE !== "1";

export default function MSICustomerShell({ children, preview = false }) {
  return (
    <div className="msi-customer-shell">
      <header className="msi-customer-header">
        <div className="msi-lockup"><img src="/icons/playswithguru-logo.png" alt="" /><span className="msi-mark">MSI</span><span className="msi-lockup-copy"><strong>Market Structure Intelligence</strong><small>by Low Point Capital</small></span></div>
        <MSICustomerNav />
      </header>
      {PREVIEW_UI_ENABLED && preview && <div className="msi-preview-banner" role="status">DESIGN PREVIEW — NON-LIVE DATA</div>}
      <main>{children}</main>
      <footer className="msi-customer-disclosure">
        <strong>We analyze the structure. We show you what we see. You decide what you do with it.</strong>
        <span>Market structure intelligence is educational and is not individualized investment advice.</span>
      </footer>
      <MSICustomerNav mobile />
    </div>
  );
}
